module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_lines-9eaeb6ff991e27f7d9e73a7ee2d990b8.png";